import { Field, TextOutput } from 'Components/Core';
import { Table } from 'Components/Layout';
import { IInterLabSampleModel } from 'Data/ReduxViewModels/InterLab/types';
import './SelectedSamplesTable.scss';

interface ISelectedSamplesTableProps {
  selectedSamples: IInterLabSampleModel[];
}

const SelectedSamplesTable: React.FC<ISelectedSamplesTableProps> = ({ selectedSamples }) => {
  const OutputField = (value?: any) => <Field input={<TextOutput />} value={value} />;

  return (
    <div className="SelectedSamplesTable">
      <Table
        colHeaders={['Sample ID', 'Sub Sample ID']}
        alternateRowShading={true}
        data={selectedSamples.map((h) => [OutputField(h.sampleId), OutputField(h.subSampleId)])}
      />
    </div>
  );
};

export { SelectedSamplesTable };
